import 'magnific-popup';

export default function popup() {

  $('.step-item__link').magnificPopup({
    type:'inline',
    midClick: true,
    mainClass: 'popup-bg',
  });

  $('[data-popup-presentation]').magnificPopup({
    type: 'inline',
    midClick: true,
    mainClass: 'custom-popup-class',
  }); 

}


// WEBPACK FOOTER //
// ./scripts/modules/popup.js